export default __webpack_public_path__ + "static/image-36-48ba842dc9c771eb1d26cf8acb5d7f1c.jpg";